export const CLOSE_MESSAGE = "CLOSE_MESSAGE";
export function closeMessage(){
    return {
        type: CLOSE_MESSAGE
    }
}


// WEBPACK FOOTER //
// ./src/actions/MessageActions.js